module.exports = __webpack_public_path__ + "media/images/icons/filled/github-dc4f89291c52c2bbd53074f6825ab7f9.svg";